<template>
	<div class="full-width">
		<!-- <v-card class="pa-5"> -->
		<h5 class="headline mb-5">{{ title }}</h5>

		<select-state-city-mm
			:showFilter="true"
			@UPDATED_VALUES="updateStateCityMm"
			:removeCityFilter="removeCityFilter"
			:removeMicroMarketFilter="removeMicroMarketFilter"
		/>

		<v-layout class="full-width" wrap v-if="retailRegistrations">
			<v-flex xs12>
				<v-layout class="my-4 verCenteredChild">
					<v-flex class="no-flex-grow pr-2 allCenteredChild">
						<h5 class="heading full-width ma-0">
							Registrations in {{ selectedState }}
						</h5>
					</v-flex>
					<v-flex class="no-flex-grow" v-show="selectedCity">
						<v-chip
							v-model="cityChip"
							:color="themeInputColor"
							text-color="white"
						>
							<strong>City</strong>
							- {{ selectedCity }}
						</v-chip>
					</v-flex>
					<v-flex class="no-flex-grow" v-show="selectedMicroMarket">
						<v-chip
							v-model="microMarketChip"
							:color="themeInputColor"
							text-color="white"
						>
							<strong>Micro-Market</strong>
							- {{ selectedMicroMarket }}
						</v-chip>
					</v-flex>
					<v-flex class="no-flex-grow">
						<v-tooltip right>
							<v-btn
								slot="activator"
								icon
								:loading="fetchRegistrationsLoading"
								@click="fetchRegistrations"
							>
								<v-icon>refresh</v-icon>
							</v-btn>
							<span>Refresh</span>
						</v-tooltip>
					</v-flex>
				</v-layout>
			</v-flex>

			<advance-list-view
				:allProps="allProps"
				:allData="retailRegistrations"
				:themeInputColor="themeInputColor"
				nextOffset="end"
				uniqueKey="id"
				@ON_ROW_CLICK="onRowClick"
				@TAKE_ACTION_ON_ROW="takeAction"
				:isTableInteractive="true"
			/>
		</v-layout>

		<user-review-form
			:themeInputColor="themeInputColor"
			:showDialog="showRetailer"
			:retailerDetails="retailerDetails"
			@CLOSE_DIALOG="showRetailer = false"
		/>
	</div>
</template>

<script>
import { mapState } from "vuex";

import AdvanceListView from "@/components/Advance-list-view";
import UserReviewForm from "./user-review-form";
import SelectStateCityMM from "@/components/select-state-city-mm";
import {
	// FETCH_REGIONS,
	FETCH_REGISTRATIONS,
	RESET_RETAIL_REGISTRATIONS
} from "@/store/action-types";

import { REGION_TYPE } from "@/utils";

export default {
	name: "Review",
	props: ["title", "themeInputColor"],
	data() {
		return {
			menu: false,
			selectedState: null,
			selectedCity: null,
			selectedMicroMarket: null,
			allProps: [
				{ text: "User ID", key: "id", copy_allowed: true },
				{ text: "Name", key: "name" },
				{ text: "City", key: "city" },
				{ text: "MicroMarket", key: "micro_market" },
				{
					text: "Handle",
					key: "handle",
					copy_allowed: true,
					text_transform: false
				},
				{
					text: "Store Type",
					key: "storeType",
					text_transform: false
				},
				{
					text: "App Type",
					key: "appTypes",
					text_transform: false
				},
				{
					text: "Store Category",
					key: "storeCategory",
					text_transform: false
				},
				{
					text: "Incorporation",
					key: "incorporationType",
					text_transform: false
				},
				{
					text: "ACTION",
					key: "Approve / Reject",
					action_button: true,
					template_type: 1
				}
			],
			showRetailer: false,
			retailerDetails: {},
			fetchRegistrationsLoading: false,
			cityChip: true,
			microMarketChip: true,
			removeMicroMarketFilter: false,
			removeCityFilter: false
		};
	},
	components: {
		"advance-list-view": AdvanceListView,
		"user-review-form": UserReviewForm,
		"select-state-city-mm": SelectStateCityMM
	},
	computed: {
		...mapState({
			retailRegistrations: state => state.retail.retailRegistrations
		})
	},
	methods: {
		updateStateCityMm(payload) {
			const {
				selectedState,
				selectedCity,
				selectedMicroMarket
			} = payload;
			this.selectedState = selectedState;
			this.selectedCity = selectedCity;
			this.selectedMicroMarket = selectedMicroMarket;
		},
		takeAction(index) {
			this.showRetailer = true;
			this.retailerDetails = this.retailRegistrations[index];
		},
		onRowClick() {},
		fetchRegistrations() {
			if (!this.fetchRegistrationsLoading && this.selectedState) {
				this.fetchRegistrationsLoading = true;
				let feedType = REGION_TYPE.STATE;
				let filterKey = this.selectedState;
				if (this.selectedCity) {
					feedType = REGION_TYPE.CITY;
					filterKey = `${filterKey}_${this.selectedCity}`;
				}
				if (this.selectedMicroMarket) {
					feedType = REGION_TYPE.MICRO_MARKET;
					filterKey = `${filterKey}_${this.selectedMicroMarket}`;
				}
				this.$store
					.dispatch(FETCH_REGISTRATIONS.dispatch, {
						feedType,
						filterKey
					})
					.catch(() => {})
					.then(() => {
						this.fetchRegistrationsLoading = false;
					});
			}
		}
	},
	watch: {
		selectedState(newVal) {
			if (newVal) this.fetchRegistrations();
			else {
				this.$store.dispatch(RESET_RETAIL_REGISTRATIONS.dispatch);
			}
		},
		selectedCity() {
			this.fetchRegistrations();
		},
		selectedMicroMarket() {
			this.fetchRegistrations();
		}
	}
};
</script>
